import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, GeneralStatusHistoryDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../../components/EntityLink/BaseEntityLink";
import GeneralStatusHistoryInline, {
  GeneralStatusHistoryInlineProps,
} from "./GeneralStatusHistoryInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: GeneralStatusHistoryDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<GeneralStatusHistoryInlineProps>;
}

export default function GeneralStatusHistoryLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.GeneralStatusHistoryRead]}
      to={ROUTE_PATH.GENERAL_STATUS_HISTORY_VIEW(entity?.id || entityId || "")}
      content={<GeneralStatusHistoryInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
